import { media } from 'styled-bootstrap-grid'
import styled from 'styled-components'

export const Header = styled.div`
  display: block;
  text-align: center;
  line-height: 1.5;

  ${({ theme }) => `
    color: ${theme.color.white};
    margin-bottom: ${theme.space.mobile.large};
  `}

  ${({ theme }) => media.sm`
    margin-bottom: ${theme.space.desktop.large};
  `}
`

export const ErrorWrapper = styled.div`
  margin-bottom: ${({ theme }) => theme.space.mobile.tiny};
`
